import { render, staticRenderFns } from "./PostByTagColumnChart.vue?vue&type=template&id=37be5490&"
import script from "./PostByTagColumnChart.vue?vue&type=script&lang=js&"
export * from "./PostByTagColumnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports